var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuditTrail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.46 283.46",
    enableBackground: "new 0 0 283.46 283.46",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M262.43,209.12H21.03c-4.7,0-8.5-3.81-8.5-8.5 V32.68c0-4.7,3.81-8.5,8.5-8.5h241.4c4.7,0,8.5,3.81,8.5,8.5v167.93C270.94,205.31,267.13,209.12,262.43,209.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M248.28,179.59H34.37V47.37 c0-1.57,1.27-2.83,2.83-2.83h208.23c1.57,0,2.83,1.27,2.83,2.83V179.59z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6300FF",
    stroke: "#6300FF",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    cx: 140.28,
    cy: 194.61,
    r: 1.86
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M60.61,264.28h160.18c1.57,0,2.83-1.27,2.83-2.83 v-5.71v-6.47c0-1.57-1.27-2.83-2.83-2.83h-34.84c-1.57,0-2.83-1.27-2.83-2.83v-13.63c0-1.57-1.27-2.83-2.83-2.83h-76.73 c-1.57,0-2.83,1.27-2.83,2.83v13.63c0,1.57-1.27,2.83-2.83,2.83H60.61c-1.57,0-2.83,1.27-2.83,2.83v6.85v5.32 C57.77,263.02,59.04,264.28,60.61,264.28z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    cx: 101.06,
    cy: 112.19,
    r: 55.61
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M66.73,112.19 c0-18.96,15.37-34.33,34.33-34.33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6300FF",
    stroke: "#6300FF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M172.53,166.59 l7.37-10.67c0.89-1.29,2.66-1.61,3.94-0.72l63.82,44.09c0.64,0.44,0.81,1.33,0.36,1.97l-8.98,13c-0.44,0.64-1.33,0.81-1.97,0.36 l-63.82-44.09C171.96,169.65,171.64,167.88,172.53,166.59z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 172.52,
    y1: 158.71,
    x2: 151.66,
    y2: 144.29
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditTrail);
export default __webpack_public_path__ + "static/media/AuditTrail.c582b5ee99a27ea4966c5a6b2f5a7b8d.svg";
export { ForwardRef as ReactComponent };